import { startOfDay, sub } from 'date-fns';

import { useCurrentDate } from '@/hooks/current-date-provider';
import { useTrackingRequests } from '@/hooks/use-tracking-requests';
import { TRACKING_STATUS } from '@/lib/models/tracking-request/types';

const ERROR_MESSAGE = 'Error fetching pending tracking requests';

interface UseTrackingRequestsProps {
  isEnabled?: boolean;
  countOnly?: boolean;
}

export const useTrackingRequestsPending = ({ isEnabled = true, countOnly = false }: UseTrackingRequestsProps = {}) => {
  const currentDate = useCurrentDate();
  const maxDate = sub(startOfDay(currentDate), { weeks: 2 });

  const { trackingRequests, count, error, isLoading } = useTrackingRequests({
    isEnabled,
    columnFilters: [
      {
        id: 'status',
        value: [TRACKING_STATUS.PENDING, TRACKING_STATUS.NEW, TRACKING_STATUS.UNTRACKABLE],
      },
      {
        id: 'maxDate',
        value: maxDate, // Only fetch trackingRequests from the last two weeks
      },
    ],
    countOnly,
  });

  const errorMessage = error ? ERROR_MESSAGE : undefined;

  return {
    isLoading,
    error: errorMessage,
    trackingRequests,
    count,
  };
};
